export const FALLBACK_SETTLEMENT_METHOD = [
  { id: 'CASH', displayValue: 'Cash' },
  { id: 'PHYSICAL', displayValue: 'Physical' },
];

